import * as List from "./list";
import * as BinHeap from "./binheap";
import * as Storage from "./storage";
import { PQ } from "./pq";

export default {
  Storage: Storage,
  List: List,
  BinHeap: BinHeap,
  PQ: PQ,
};
